@if (loadPage && templateConfig.showDepositsPanel === 'true' && dataGrid.length > 0) {
	<section class="mb-[40px]">
		<lbca-deposits-panel
			[value]="dataGrid"
			[cardData]="cardInfo"
			[dataAttr]="dataAttr"
		></lbca-deposits-panel>
	</section>
}

@if (
	loadPage &&
	(templateConfig.canAdd === 'true' || (templateConfig.canEdit === 'true' && editControl)) &&
	!isDisabled
) {
	<section
		class="mig-component rounded-lg shadow-inner p-4"
		[class.mb-[10px]]="dataGrid.length > 0"
	>
		<div [class.ff-row-form]="rowform" [class.w-full]="!rowform" class="ff-grid-margin">
			@for (row of fieldList; track row) {
				@if (row.fields) {
					<div class="ff-row-form ff-grid-margin ml-[20px]">
						@if (row.label && row.fields) {
							<div class="inline-flex items-center mb-[12px]">
								@if (false) {
									<div class="h-1 w-1 rounded ml-[8px] mr-[8px]"></div>
								}
								<p class="text-font text-xs">{{ row.label }}</p>
							</div>
						}
					</div>
					@if (row.fields.length) {
						@for (rowlist of row.fields; track rowlist) {
							<div class="ff-row-form">
								@for (collist of rowlist; track collist) {
									<ng-container
										[ngTemplateOutlet]="formData"
										[ngTemplateOutletContext]="{ $implicit: collist, dataAttr: dataAttr }"
									></ng-container>
								}
							</div>
						}
					}
					@if (!row.fields.length) {
						<!-- fields: [ {}, {} ] -->
						<div [class.ff-row-form]="!rowform">
							@for (col of row.fields; track col) {
								<ng-container
									[ngTemplateOutlet]="formData"
									[ngTemplateOutletContext]="{ $implicit: col, dataAttr: dataAttr }"
								></ng-container>
							}
						</div>
					}
				}
				@if (!row.fields) {
					<!-- sem configuracao de template, configuration primary / secondary expected: [ [ {}, {} ] ] ou [ {}, {} ]  -->
					<ng-container
						[ngTemplateOutlet]="formData"
						[ngTemplateOutletContext]="{ $implicit: row, dataAttr: dataAttr }"
					></ng-container>
				}
			}
		</div>
		<div class="ff-row-form ff-grid-margin">
			<div class="ff-box-field ff-grid-field mig-fields-container">
				@if (!editControl && !isDisabled && templateConfig.canAdd === 'true') {
					<button
						class="btn-type-2"
						[class.btn-primary]="!hasError"
						[class.btn-danger]="hasError"
						(click)="addToTable($event, fieldList)"
					>
						Adicionar
					</button>
				}
				@if (editControl && !isDisabled && templateConfig.canEdit === 'true') {
					<button
						class="btn-type-2"
						[class.btn-primary]="!hasError"
						[class.btn-danger]="hasError"
						(click)="updateTable($event, fieldList)"
					>
						Atualizar
					</button>
				}
				@if (isDisabled) {
					<button
						class="btn-type-2"
						[class.btn-primary]="!hasError"
						[class.btn-danger]="hasError"
						disabled="isDisabled"
					>
						Adicionar
					</button>
				}
			</div>
		</div>
	</section>
}

<ng-template #formData let-context let-dataAttr="dataAttr">
	@if (
		dynamicFormService.formControlStructure.fieldControl[context.entityKey]
			? dynamicFormService.formControlStructure.fieldControl[context.entityKey].visible
			: false
	) {
		<div
			[ngClass]="'ff-field-size-' + context.size"
			[class.ff-box-field]="!(context.size === 0)"
			[class.ff-grid-margin]="!(context.size === 0)"
			class="ff-grid-field ff-box-field"
		>
			@if (context.type === 'GRIDBOX') {
				<lbca-gridbox
					[field]="context"
					[template]="context.template"
					[label]="context.label"
					[configuration]="context.configuration"
					[require]="context.required"
					[helperText]="context.helperText"
					[labeled]="true"
					[dynamicFormService]="dynamicFormService"
					[dataAttr]="dataAttr"
					[cardData]="cardInfo"
					[disabled]="
						disabedControll ||
						context.disabled ||
						(context.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[context.entityKey].disabled)
					"
					(setError)="subFormModuleInstance(context.entityKey, 'error', $event)"
					(validState)="subFormModuleInstance(context.entityKey, 'valid', $event)"
					(changeValue)="subFormModuleInstance(context.entityKey, 'value', $event)"
					[gridFormModuleInstance]="gridFormModuleInstance"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[context.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[context.entityKey].error
							: []
					"
					[value]="context.value"
				></lbca-gridbox>
			}
			@if (context.type === 'GRIDBOX_UNIQUE') {
				<lbca-gridbox-unique
					[field]="context"
					[cardData]="cardInfo"
					[configuration]="context.configuration"
					[label]="context.label"
					[labeled]="true"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[context.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[context.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						context.disabled ||
						(context.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[context.entityKey].disabled)
					"
					[require]="context.required"
					(setError)="subFormModuleInstance(context.entityKey, 'error', $event)"
					(validState)="subFormModuleInstance(context.entityKey, 'valid', $event)"
					(changeValue)="changeFieldGridUnique($event, context)"
					[value]="context.value"
					[helperText]="context.helperText"
				></lbca-gridbox-unique>
			}
			@if (context.type === 'HIDDEN') {
				<lbca-input-hidden
					[label]="context.label"
					[defaultValue]="context.defaultValue"
				></lbca-input-hidden>
			}
			@if (context.type === 'TEXT') {
				<lbca-input-text
					[label]="context.label"
					[labeled]="true"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[context.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[context.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						context.disabled ||
						(context.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[context.entityKey].disabled)
					"
					[require]="context.required"
					[maskInput]="context.mask"
					[value]="context.value"
					(errorState)="subFormModuleInstance(context.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(context.entityKey, 'valid', $event)"
					(changeValue)="changeField($event, context)"
				></lbca-input-text>
			}
			@if (context.type === 'CALENDAR') {
				<lbca-date-picker
					[labeled]="true"
					[label]="context.label"
					[require]="context.required"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[context.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[context.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						context.disabled ||
						(context.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[context.entityKey].disabled)
					"
					[value]="context.value"
					[rules]="context.rules"
					[disabledDateRules]="context.disabledDateRules"
					(errorState)="subFormModuleInstance(context.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(context.entityKey, 'valid', $event)"
					(changeValue)="changeField($event, context)"
				></lbca-date-picker>
			}
			@if (context.type === 'TIME') {
				<lbca-timepicker
					[labeled]="true"
					[label]="context.label"
					[require]="context.required"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[context.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[context.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						context.disabled ||
						(context.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[context.entityKey].disabled)
					"
					[value]="context.value"
					(errorState)="subFormModuleInstance(context.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(context.entityKey, 'valid', $event)"
					(changeValue)="changeField($event, context)"
				></lbca-timepicker>
			}
			@if (context.type === 'DATE_TIME') {
				<lbca-date-time-picker
					[labelDate]="context.labelDate"
					[labelTime]="context.labelTime"
					[require]="context.required"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[context.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[context.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						context.disabled ||
						(context.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[context.entityKey].disabled)
					"
					[value]="context.value"
					[rules]="context.rules"
					[disabledDateRules]="context.rules"
					(errorState)="subFormModuleInstance(context.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(context.entityKey, 'valid', $event)"
					(changeValue)="changeField($event, context)"
					[labeled]="true"
				></lbca-date-time-picker>
			}
			@if (context.auxEntity) {
				<lbca-entity-fields
					id="{{ context.entityKey }}"
					[forceType]="context.type === 'LIST_REF' ? 'LIST_REF' : 'SELECT_ONE'"
					[labeled]="true"
					[field]="context"
					[label]="context.label"
					[cardData]="cardInfo"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[context.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[context.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						context.disabled ||
						(context.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[context.entityKey].disabled)
					"
					[require]="context.required"
					[value]="context.value"
					(errorState)="subFormModuleInstance(context.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(context.entityKey, 'valid', $event)"
					(changeValue)="changeField($event, context)"
				></lbca-entity-fields>
			}
			@if (context.type === 'TEXTAREA') {
				<lbca-textarea
					[label]="context.label"
					[labeled]="true"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[context.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[context.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						context.disabled ||
						(context.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[context.entityKey].disabled)
					"
					[require]="context.required"
					[value]="context.value"
					(errorState)="subFormModuleInstance(context.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(context.entityKey, 'valid', $event)"
					(changeValue)="changeField($event, context)"
				></lbca-textarea>
			}
			@if (context.type === 'FILE_UPLOAD') {
				<lbca-sub-module-file-upload
					[idEntity]="context.entityKey"
					[value]="context.value"
					[label]="context.label"
					[dataAttr]="dataAttr"
					[cardData]="cardInfo"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[context.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[context.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						context.disabled ||
						(context.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[context.entityKey].disabled)
					"
					(saveValue)="saveUpload($event)"
					[properties]="context"
				></lbca-sub-module-file-upload>
			}
			@if (context.type === 'ADDITIONAL_VALUES') {
				<lbca-additional-values
					[field]="context.fields"
					[value]="context.value"
					[cardData]="cardInfo"
					[disabled]="
						disabedControll ||
						context.disabled ||
						(context.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[context.entityKey].disabled)
					"
					(errorState)="subFormModuleInstance(context.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(context.entityKey, 'valid', $event)"
					(changeValue)="changeFieldGroup($event, context)"
				></lbca-additional-values>
			}
			@if (context.type === 'SELECT_TREE') {
				<lbca-select-tree
					[field]="context"
					[label]="context.label"
					[error]="
						dynamicFormService.formControlStructure.fieldControl[context.entityKey]
							? dynamicFormService.formControlStructure.fieldControl[context.entityKey].error
							: []
					"
					[disabled]="
						disabedControll ||
						context.disabled ||
						(context.childrenDependency &&
							dynamicFormService.formControlStructure.fieldControl[context.entityKey].disabled)
					"
					[require]="context.required"
					[cardData]="cardInfo"
					(errorState)="subFormModuleInstance(context.entityKey, 'error', $event)"
					(validStatus)="subFormModuleInstance(context.entityKey, 'valid', $event)"
					(changeValue)="changeField($event, context)"
					(changeProperties)="subFormModuleInstance(context.entityKey, 'properties', $event)"
					[value]="context.value"
				></lbca-select-tree>
			}
			@if (context.type === 'INPUT_REF') {
				<legalboxplus-input-reference
					[label]="context.label"
					[field]="context"
					[value]="_data ? _data[context.entityKey] : ''"
				></legalboxplus-input-reference>
			}
			@if (context.type === 'FILE_FROM_PROCESS') {
				<lbca-file-from-process
					[label]="context.label"
					[buttonLabel]="context.buttonLabel"
					[value]="data ? data[context.entityKey] : ''"
					[context]="context.context"
					[cardData]="cardInfo"
					[properties]="context"
					(saveValue)="saveUpload($event)"
				>
					>
				</lbca-file-from-process>
			}
		</div>
	}
</ng-template>
@if (dataGrid.length <= 0 && isDisabled && !isReadonly) {
	@for (row of fieldList; track row) {
		<div>
			@if (row.label && row.fields) {
				<div class="inline-flex items-center">
					@if (false) {
						<div class="h-1 w-1 rounded ml-[8px] mr-[8px]"></div>
					}
					<p class="text-font text-xs">{{ row?.label }}</p>
				</div>
			}
			<p class="text-base">-</p>
		</div>
	}
}

@if (dataGrid.length > 0 && loadPage) {
	<div class="w-full mt-[10px]">
		<lbca-table-condensed
			[config]="config"
			[columns]="columns"
			[details]="details"
			[body]="body"
			[cardData]="cardInfo"
			[dataAttr]="dataAttr"
			[removeLine]="lineremove"
			[rightDeslocation]="line"
			[paginationType]="paginationType"
			[totalPagesValue]="totalPagesValue"
			[lineCickable]="false"
			(changeValue)="changeValueTable($event)"
			[dynamicFormService]="dynamicFormService"
			[highlight]="templateConfig.childGrid || false"
			(order)="orderTable($event)"
		></lbca-table-condensed>
	</div>
}

<ng-template #actionsRender let-content>
	@if (!isDisabled || editControl) {
		<div class="mig-actions-container">
			@if (templateConfig.canEdit === 'true') {
				<label
					class="mig-edit"
					(click)="editItemGrid($event, content, (editControl = !editControl))"
				>
					@if (!content.edit) {
						<div>
							<lbca-icon name="lucide:pencil" size="small" class="text-gray-300"></lbca-icon>
						</div>
					}
					@if (content.edit) {
						<lbca-icon name="lucide:x" size="small" class="text-gray-300" />
					}
				</label>
			}
			@if (templateConfig.canDelete === 'true') {
				<label class="mig-delete" (click)="deleteItemGridConfirm($event, content)">
					@if (!content.remove) {
						<lbca-icon name="lucide:trash" size="small" class="text-gray-300"></lbca-icon>
					}
					@if (content.remove) {
						<lbca-icon name="lucide:x" size="small" class="text-gray-300" />
					}
				</label>
			}
		</div>
	}
</ng-template>

<ng-template #delete_count let-content>
	<span
		class="transition duration-600 ease-in-out"
		style="animation-delay: 5s"
		[class.opacity-0]="content.remove"
		[class.opacity-100]="!content.remove"
	>
		{{ content.index }}
	</span>
</ng-template>

<ng-template #templateRemove>
	<div class="text-base text-font flex items-center justify-center show">
		Item excluído!
		<lbca-icon name="emoji--wastebasket" class="icon-box ml-[16px]"></lbca-icon>
	</div>
</ng-template>

<ng-template #templateCopy>
	<div class="text-base text-font flex items-center justify-center show">
		Copiado!
		<lbca-icon name="emoji--smile" class="emojis-smile icon-box ml-[16px]"></lbca-icon>
	</div>
</ng-template>
